import { useEffect, useState } from "react";
import { fetchAuthImage, type UploadImageKind } from "../lib/api";

interface Props {
  uniqid: string;
  kind: UploadImageKind;
  alt: string;
  className?: string;
  /** contain zeigt das ganze Bild (Detailansicht), cover füllt die Kachel. */
  fit?: "cover" | "contain";
}

export default function AuthImage({
  uniqid,
  kind,
  alt,
  className,
  fit = "cover",
}: Props) {
  const [url, setUrl] = useState<string | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let revoked = false;
    let objectUrl: string | null = null;
    setError(false);
    setUrl(null);
    fetchAuthImage(uniqid, kind)
      .then((u) => {
        if (revoked) {
          URL.revokeObjectURL(u);
          return;
        }
        objectUrl = u;
        setUrl(u);
      })
      .catch(() => setError(true));
    return () => {
      revoked = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [uniqid, kind]);

  const box = `flex w-full items-center justify-center bg-muted text-xs text-muted-foreground ${className ?? ""}`;
  if (error) return <div className={box}>fehlt</div>;
  if (!url) return <div className={`${box} animate-pulse`} aria-busy="true" />;
  return (
    <img
      className={`w-full bg-muted ${fit === "contain" ? "object-contain" : "object-cover"} ${className ?? ""}`}
      src={url}
      alt={alt}
    />
  );
}
